export default "__VITE_ASSET__BLDzAJ1g__"